import { State } from '@/helpers/entities/enums/v2/State';
export class BaseInputModel {
    constructor() {
        this.state = State.new;
    }
    get isNew() {
        return this.state === State.new;
    }
    get isIdle() {
        return this.state === State.idle;
    }
    get isDeleted() {
        return this.state === State.deleted;
    }
    get isHidden() {
        return this.state === State.hidden;
    }
    markAsDeleted() {
        this.state = State.deleted;
    }
    markAsFetched() {
        this.persistent = true;
        this.state = State.idle;
    }
}
